import React, {Component} from "react";
import {IonBadge, IonChip, IonItem, IonLabel} from "@ionic/react";
import SeriesItem, {isKnownArena} from "../../domain/SeriesItem";
import {RouteComponentProps} from "react-router";
import StringUtils from "../../utils/String.utils";

type Props = RouteComponentProps<{ contestId: string, tab: string }> & {
  series: SeriesItem;
};

type State = {}

export default class SeriesListItem extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    const {series} = this.props;
    let startList = `/contests/${this.props.match.params.contestId}/series/${series.id}/startlist`;
    let hour = null;
    if (series.startHour) {
      hour =
        <IonChip slot="end">{StringUtils.pad(series.startHour, 2)}:{StringUtils.pad(series.startMinutes, 2)}</IonChip>;
    }
    let arena = null;
    if (this.shouldShowArena(series)) {
      arena = <IonBadge class="arena-code" slot="start">
        {series.arena}
      </IonBadge>;
    }
    return (
      <IonItem class={"series-list-item"}
               button
               onClick={() => this.props.history.push(startList)}>
        {arena}
        <IonLabel>
          {series.difficulty}
        </IonLabel>
        {hour}
      </IonItem>
    );
  }

  private shouldShowArena(series:SeriesItem) {
    return ('dressage' === series.type || 'group-dressage' === series.type) && isKnownArena(series.arena);
  }
}
